import { render, staticRenderFns } from "./dayBill.vue?vue&type=template&id=552bd99f&scoped=true"
import script from "./dayBill.vue?vue&type=script&lang=js"
export * from "./dayBill.vue?vue&type=script&lang=js"
import style0 from "./dayBill.vue?vue&type=style&index=0&id=552bd99f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552bd99f",
  null
  
)

export default component.exports